module.exports = {
	name: 'text',
	validation(yup) {
		return yup.string();
	}
};
